export enum ExchangeEnum{
  Exchange = 1,
  FancyBet = 2,
  Premium = 4,
  BookMaker = 5,
}